<template>
  <div class="w-full">
    <vs-popup
      :active.sync="localActive"
      :title="tituloModal"
      class="modal-disparo-massa"
      size="large"
    >
      <div class="vs-con-loading__container w-full" id="cobrancaDisparoMassaContainer">
        
        <!-- ESTADO DE PROGRESSO EM TEMPO REAL -->
        <div v-if="etapa === 'progresso'" class="progress-section py-6 px-4">
          <div class="text-center mb-6">
            <div class="spinner-container mb-4">
              <span v-if="progress.status === 'processing'" class="dot-pulse"></span>
              <vs-icon 
                v-else 
                :icon="progress.status === 'completed' ? (progress.failed > 0 ? (progress.sent === 0 ? 'error' : 'warning') : 'check_circle') : 'error'" 
                size="60px" 
                :color="corStatus"
              />
            </div>
            <h4 class="font-bold text-xl" style="color: #1e293b;">
              <template v-if="progress.status === 'completed'">
                <span v-if="progress.failed > 0 && progress.sent === 0">Envio finalizado com erro!</span>
                <span v-else-if="progress.failed > 0 && progress.sent > 0">Envio finalizado com falhas parciais!</span>
                <span v-else>Processamento finalizado com sucesso!</span>
              </template>
              <template v-else>
                {{ progress.message }}
              </template>
            </h4>
          </div>

          <!-- Barra de Progresso -->
          <div class="progress-container mb-6">
            <div class="progress-info">
              <span class="text-sm font-semibold">Progresso do Envio</span>
              <span class="text-sm font-bold" :style="{ color: corStatus }">{{ progress.percent }}%</span>
            </div>
            <div class="progress-bar-bg">
              <div 
                class="progress-bar-fill" 
                :style="{ width: progress.percent + '%', backgroundColor: corStatus }"
              ></div>
            </div>
          </div>

          <!-- Contadores -->
          <div class="counters-grid">
            <div class="counter-card">
              <vs-icon icon="list_alt" size="24px" color="#00bba2"></vs-icon>
              <span class="counter-value">{{ progress.total }}</span>
              <span class="counter-label">Total</span>
            </div>
            <div class="counter-card counter-success">
              <vs-icon icon="check_circle" size="24px" color="#28c76f"></vs-icon>
              <span class="counter-value text-success">{{ progress.sent }}</span>
              <span class="counter-label">Enviados</span>
            </div>
            <div class="counter-card counter-danger">
              <vs-icon icon="cancel" size="24px" color="#ea5455"></vs-icon>
              <span class="counter-value text-danger">{{ progress.failed }}</span>
              <span class="counter-label">Falhas</span>
            </div>
          </div>

          <!-- Botão Final & Cancelar -->
          <div class="text-center mt-8">
            <template v-if="progress.status === 'completed' || progress.status === 'error' || progress.status === 'cancelled' || progress.status === 'interrupted'">
              <vs-button
                :color="progress.status === 'completed' ? (progress.failed > 0 ? (progress.sent === 0 ? 'danger' : 'warning') : 'success') : (progress.status === 'cancelled' ? 'warning' : 'danger')"
                size="large"
                icon="done_all"
                @click="fecharComSucesso"
              >
                <template v-if="progress.status === 'completed'">
                  <span v-if="progress.failed > 0 && progress.sent === 0">Fechar (Falha Geral)</span>
                  <span v-else-if="progress.failed > 0 && progress.sent > 0">Concluído com Alerta</span>
                  <span v-else>Concluído! Fechar</span>
                </template>
                <template v-else-if="progress.status === 'cancelled'">
                  Cancelado ({{ progress.sent }} Enviados) — Fechar
                </template>
                <template v-else-if="progress.status === 'interrupted'">
                  Interrompido — Fechar
                </template>
                <template v-else>
                  Fechar
                </template>
              </vs-button>
            </template>
            <div v-else class="flex justify-center items-center" style="gap: 12px;">
              <vs-button disabled color="dark" type="border" size="large">
                <span class="dot-pulse-inline"></span> Processando...
              </vs-button>
              <vs-button color="danger" type="filled" icon="cancel" size="large" @click="abrirModalConfirmarCancelamento">
                CANCELAR DISPARO
              </vs-button>
            </div>
          </div>
        </div>

        <!-- ESTADO NORMAL: TABS DE NOVO ENVIO & HISTÓRICO -->
        <div v-else>
          <vs-tabs color="#00bba2" v-model="abaAtiva" v-if="localActive">
            
            <!-- TAB 1: NOVO DISPARO -->
            <vs-tab label="Novo Disparo" icon="send">
              <div class="py-4">
                
                <!-- Info Cards -->
                <div class="info-cards mb-4" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: 8px;">
                  <div class="info-card info-card-success">
                    <vs-icon icon="check_circle_outline" size="20px" color="#28c76f"></vs-icon>
                    <div>
                      <span class="info-card-number">{{ contasElegiveis.length }}</span>
                      <span class="info-card-text">Prontas para Envio</span>
                    </div>
                  </div>

                  <!-- Boleto (<= 60d) -->
                  <div class="info-card info-card-boleto" style="background: #f0f9ff; border: 1px solid #bae6fd; border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
                    <span style="display: flex; align-items: center; color: #0284c7;">
                      <AppIcon name="boleto" size="20" />
                    </span>
                    <div>
                      <span class="info-card-number" style="font-size: 15px; font-weight: 700; color: #0369a1;">{{ totalBoletosValidos }}</span>
                      <span class="info-card-text" style="font-size: 10px; color: #0284c7; display: block;">Boleto (≤ 60d)</span>
                    </div>
                  </div>

                  <!-- PIX -->
                  <div class="info-card info-card-pix" style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
                    <span style="display: flex; align-items: center; color: #00bba2;">
                      <AppIcon name="pix" size="20" />
                    </span>
                    <div>
                      <span class="info-card-number" style="font-size: 15px; font-weight: 700; color: #008775;">{{ totalPix }}</span>
                      <span class="info-card-text" style="font-size: 10px; color: #00bba2; display: block;">PIX</span>
                    </div>
                  </div>

                  <!-- Cartão -->
                  <div class="info-card info-card-cartao" style="background: #faf5ff; border: 1px solid #e9d5ff; border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
                    <span style="display: flex; align-items: center; color: #7e22ce;">
                      <AppIcon name="card" size="18" />
                    </span>
                    <div>
                      <span class="info-card-number" style="font-size: 15px; font-weight: 700; color: #7e22ce;">{{ totalCartao }}</span>
                      <span class="info-card-text" style="font-size: 10px; color: #7e22ce; display: block;">Cartão</span>
                    </div>
                  </div>

                  <!-- Dinheiro -->
                  <div class="info-card info-card-dinheiro" style="background: #ecfdf5; border: 1px solid #a7f3d0; border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
                    <span style="display: flex; align-items: center; color: #047857;">
                      <AppIcon name="cash" size="18" />
                    </span>
                    <div>
                      <span class="info-card-number" style="font-size: 15px; font-weight: 700; color: #047857;">{{ totalDinheiro }}</span>
                      <span class="info-card-text" style="font-size: 10px; color: #047857; display: block;">Dinheiro</span>
                    </div>
                  </div>

                  <!-- Transferência -->
                  <div class="info-card info-card-transferencia" style="background: #eef2ff; border: 1px solid #c7d2fe; border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
                    <span style="display: flex; align-items: center; color: #4338ca;">
                      <AppIcon name="bank" size="18" />
                    </span>
                    <div>
                      <span class="info-card-number" style="font-size: 15px; font-weight: 700; color: #4338ca;">{{ totalTransferencia }}</span>
                      <span class="info-card-text" style="font-size: 10px; color: #4338ca; display: block;">Transferência</span>
                    </div>
                  </div>

                  <!-- Negociação (> 60d) -->
                  <div class="info-card info-card-renegociacao" v-if="totalExpiradosRenegociacao > 0" style="background: #fff7ed; border: 1px solid #fed7aa; border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; gap: 8px;">
                    <span style="display: flex; align-items: center; color: #ea580c;">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                    </span>
                    <div>
                      <span class="info-card-number" style="font-size: 15px; font-weight: 700; color: #c2410c;">{{ totalExpiradosRenegociacao }}</span>
                      <span class="info-card-text" style="font-size: 10px; color: #ea580c; display: block;">Negociação (> 60d)</span>
                    </div>
                  </div>

                  <!-- Outras Formas (Empenho / Permuta / Outros) -->
                  <div class="info-card info-card-outros" v-if="totalOutros > 0" style="background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 8px; padding: 8px 12px; display: flex; align-items: center; gap: 8px;" title="Contas com Empenho, Permuta, Outro Contrato ou outras modalidades">
                    <span style="display: flex; align-items: center; color: #475569;">
                      <AppIcon name="file" size="18" />
                    </span>
                    <div>
                      <span class="info-card-number" style="font-size: 15px; font-weight: 700; color: #475569;">{{ totalOutros }}</span>
                      <span class="info-card-text" style="font-size: 10px; color: #64748b; display: block;">Outras Formas</span>
                    </div>
                  </div>

                  <!-- Sem Contato -->
                  <div class="info-card info-card-warning" v-if="contasList.length - contasElegiveis.length > 0">
                    <vs-icon icon="warning" size="20px" color="#ff9f43"></vs-icon>
                    <div>
                      <span class="info-card-number">{{ contasList.length - contasElegiveis.length }}</span>
                      <span class="info-card-text">Sem Contato</span>
                    </div>
                  </div>
                </div>

                <!-- Lista de Destinatários Elegíveis -->
                <div class="mb-4" v-if="contasElegiveis.length > 0">
                  <div class="flex items-center justify-between mb-2">
                    <label class="select-label m-0">Invoices Selecionadas ({{ contasSelecionadas.length }} de {{ contasElegiveis.length }})</label>
                    <vs-checkbox 
                      @input="toggleAll" 
                      :value="contasSelecionadas.length === contasElegiveis.length" 
                      color="success"
                      class="text-xs font-semibold text-grey-dark"
                    >
                      Selecionar Todos
                    </vs-checkbox>
                  </div>
                  <p class="text-xs mb-2" style="color: #475569;">
                    Ordem de envio: 1º contato financeiro, 2º contato de confirmação. Conta sem nenhum dos dois não é enviada.
                  </p>
                  <div class="destinatarios-lista">
                    <div 
                      v-for="item in contasElegiveisExibidas" 
                      :key="item.id" 
                      class="destinatario-item"
                    >
                      <div class="mr-3">
                        <vs-checkbox v-model="contasSelecionadas" :vs-value="item.id" color="success"></vs-checkbox>
                      </div>
                      <div class="destinatario-main">
                        <div class="destinatario-os cursor-pointer" @click="toggleConta(item.id)" style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                          <span>Nota #{{ item.numero }} / Conta #{{ item.id }}</span>
                          
                          <!-- BADGE ESPECÍFICO POR FORMA DE PAGAMENTO REAL -->
                          <template v-if="getBadgeItem(item)">
                            <span 
                              class="cobranca-tipo-badge"
                              :class="getBadgeItem(item).class"
                              :title="getBadgeItem(item).title"
                            >
                              <AppIcon :name="getBadgeItem(item).type" size="12" style="display: inline-block; vertical-align: -1px; margin-right: 2px;" />
                              {{ getBadgeItem(item).text }}
                            </span>
                          </template>

                          <!-- BADGE DE QUITAÇÃO PARCIAL SE HOUVER -->
                          <span 
                            v-if="item.id_status === 3" 
                            class="cobranca-tipo-badge"
                            style="background: #fef3c7; color: #b45309; border: 1px solid #fde68a; font-weight: 700;"
                            title="Conta com quitação parcial registrada no financeiro"
                          >
                            Quit. Parcial
                          </span>
                        </div>
                        <div class="destinatario-cliente">{{ item.nomeCliente }}</div>
                      </div>
                      <div class="destinatario-contato">
                        <span class="cobranca-tipo-badge badge-origem-envio" v-if="item.destinatarioCobrancaOrigem">
                          {{ origemEnvioLabel(item.destinatarioCobrancaOrigem) }}
                        </span>
                        <span class="destinatario-nome-contato" v-if="nomeDestinatario(item)">
                          {{ nomeDestinatario(item) }}:
                        </span>
                        <span 
                          class="destinatario-fone" 
                          :class="{ 'fone-incompleto': !isTelefoneValido(contatoDestinatario(item)) }"
                          :title="!isTelefoneValido(contatoDestinatario(item)) ? 'Número incompleto ou não reconhecido no cadastro' : ''"
                        >
                          {{ formatarTelefoneExibicao(contatoDestinatario(item)) }}
                          <span v-if="!isTelefoneValido(contatoDestinatario(item))" class="badge-incompleto">
                            Incompleto
                          </span>
                        </span>
                      </div>
                    </div>
                    <!-- Carregar Mais -->
                    <div v-if="contasElegiveis.length > limiteExibicao" class="text-center py-2" style="background: rgba(0, 187, 162, 0.03); border-top: 1px dashed #edf2f7;">
                      <a href="javascript:void(0)" @click="limiteExibicao += 30" class="text-xs font-semibold" style="color: #00bba2; text-decoration: none;">
                        Mostrar mais {{ Math.min(30, contasElegiveis.length - limiteExibicao) }} de {{ contasElegiveis.length - limiteExibicao }} contatos...
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Template Select -->
                <div class="mb-6">
                  <label class="select-label">Template de Mensagem WATI</label>
                  
                  <div v-if="loadingTemplates" class="skeleton-container">
                    <div class="skeleton-line skeleton-input animate-shimmer"></div>
                  </div>

                  <el-select
                    v-else
                    v-model="templateSelecionadoId"
                    class="w-full"
                    size="medium"
                    placeholder="Selecione o template de cobrança..."
                    popper-class="popper-select-template"
                    >
                    <el-option
                      v-for="tpl in watiTemplates"
                      :key="tpl.id"
                      :value="tpl.id"
                      :label="tpl.elementName"
                    ></el-option>
                  </el-select>
                </div>

                <!-- Ações -->
                <div class="flex justify-end" style="gap: 12px;">
                  <vs-button color="dark" type="border" @click="closeModal">
                    Cancelar
                  </vs-button>
                  <vs-button 
                    color="#00bba2" 
                    icon="send" 
                    @click="confirmarEnvio"
                    :disabled="contasSelecionadas.length === 0 || !templateSelecionadoId"
                  >
                    Confirmar Disparo ({{ contasSelecionadas.length }} Contatos)
                  </vs-button>
                </div>

              </div>
            </vs-tab>

            <!-- TAB 2: HISTÓRICO DE ENVIOS (APPLE DESIGN) -->
            <vs-tab label="Histórico de Envios" icon="history">
              <div class="py-4">
                
                <!-- Apple-Grade Filter Toolbar -->
                <div class="apple-history-filter-bar mb-4">
                  <div class="filter-periodo-group">
                    <span class="filter-bar-label">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                      Período:
                    </span>
                    <select 
                      v-model="filtroHistoricoDias" 
                      @change="aoMudarFiltroDias"
                      class="apple-select-input"
                    >
                      <option :value="30">Últimos 30 dias</option>
                      <option :value="7">Últimos 7 dias</option>
                      <option :value="60">Últimos 60 dias</option>
                      <option :value="90">Últimos 90 dias</option>
                      <option value="custom">Personalizado</option>
                    </select>
                  </div>

                  <div v-if="filtroHistoricoDias === 'custom'" class="filter-custom-dates">
                    <div class="custom-date-field">
                      <span class="date-sublabel">DE:</span>
                      <input 
                        type="date" 
                        v-model="filtroHistoricoDataInicio" 
                        class="apple-date-input"
                      />
                    </div>
                    <div class="custom-date-field">
                      <span class="date-sublabel">ATÉ:</span>
                      <input 
                        type="date" 
                        v-model="filtroHistoricoDataFim" 
                        class="apple-date-input"
                      />
                    </div>
                  </div>

                  <button 
                    class="apple-filter-btn" 
                    @click="fetchHistorico(true)"
                    title="Aplicar filtro no histórico"
                  >
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8"></circle>
                      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                    <span>Filtrar</span>
                  </button>
                </div>

                <!-- Tabela Apple-Grade -->
                <div class="apple-table-card">
                  <vs-table 
                    :data="tabelaDados" 
                    max-items="5" 
                    pagination 
                    search 
                    noDataText="Nenhum disparo de cobrança encontrado."
                    :class="{ 'table-loading': loadingHistorico }"
                    class="apple-history-table"
                  >
                    <template slot="thead">
                      <vs-th sort-key="createdAt">Data</vs-th>
                      <vs-th sort-key="templateName">Template</vs-th>
                      <vs-th sort-key="status">Status</vs-th>
                      <vs-th sort-key="enviados">Enviados</vs-th>
                      <vs-th>Ações</vs-th>
                    </template>
                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <!-- Data -->
                        <vs-td :data="data[indextr].createdAt">
                          <div v-if="data[indextr].isSkeleton" class="skeleton-cell" style="width: 130px; height: 16px;"></div>
                          <div v-else class="cell-date-container">
                            <span class="cell-date-text">{{ formatData(data[indextr].createdAt) }}</span>
                          </div>
                        </vs-td>

                        <!-- Template -->
                        <vs-td :data="data[indextr].templateName">
                          <div v-if="data[indextr].isSkeleton" class="skeleton-cell" style="width: 180px; height: 22px; border-radius: 6px;"></div>
                          <div v-else class="cell-template-container">
                            <code class="apple-template-code">{{ data[indextr].templateName }}</code>
                          </div>
                        </vs-td>

                        <!-- Status Badge Apple -->
                        <vs-td :data="data[indextr].status">
                          <div v-if="data[indextr].isSkeleton" class="skeleton-cell" style="width: 90px; height: 22px; border-radius: 100px;"></div>
                          <span v-else class="apple-status-pill" :class="getStatusMeta(data[indextr].status).class">
                            <!-- Ícone Completed -->
                            <svg v-if="getStatusMeta(data[indextr].status).icon === 'check'" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                            <!-- Ícone Cancelled -->
                            <svg v-else-if="getStatusMeta(data[indextr].status).icon === 'ban'" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line></svg>
                            <!-- Ícone Processing -->
                            <svg v-else-if="getStatusMeta(data[indextr].status).icon === 'spin'" class="animate-spin" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>
                            <!-- Ícone Falha -->
                            <svg v-else-if="getStatusMeta(data[indextr].status).icon === 'alert'" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                            <!-- Default Clock -->
                            <svg v-else width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                            <span>{{ getStatusMeta(data[indextr].status).label }}</span>
                          </span>
                        </vs-td>

                        <!-- Enviados -->
                        <vs-td :data="data[indextr].enviados">
                          <div v-if="data[indextr].isSkeleton" class="skeleton-cell" style="width: 45px; height: 16px;"></div>
                          <div v-else class="cell-enviados-container">
                            <span class="enviados-destaque">{{ data[indextr].enviados }}</span>
                            <span class="enviados-divisor">/</span>
                            <span class="enviados-total">{{ data[indextr].totalOs }}</span>
                          </div>
                        </vs-td>

                        <!-- Ações com SVG Clean (Sem icon quebrado / Sem emoji) -->
                        <vs-td>
                          <div v-if="data[indextr].isSkeleton" class="skeleton-cell" style="width: 85px; height: 24px; border-radius: 6px;"></div>
                          <template v-else>
                            <!-- Botão Ver Progresso (se processando) -->
                            <button 
                              v-if="data[indextr].status === 'processing'" 
                              class="apple-action-btn btn-primary" 
                              @click="retomarProgresso(data[indextr])"
                              title="Acompanhar envio em andamento"
                            >
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                              <span>Ver Progresso</span>
                            </button>
                            
                            <!-- Botão Ver Falhas (se houver falhas com SVG limpo) -->
                            <button 
                              v-else-if="data[indextr].falhas > 0" 
                              class="apple-action-btn btn-danger" 
                              @click="abrirDetalheFalhas(data[indextr].id)"
                              title="Visualizar contatos que falharam"
                            >
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="8" x2="12" y2="12"></line>
                                <line x1="12" y1="16" x2="12.01" y2="16"></line>
                              </svg>
                              <span>Ver Falhas ({{ data[indextr].falhas }})</span>
                            </button>

                            <!-- Tag Sem Falhas (100% Sucesso com SVG elegante) -->
                            <div v-else class="apple-status-tag tag-success" title="Todos os contatos receberam com sucesso">
                              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                              </svg>
                              <span>Sem Falhas</span>
                            </div>

                            <button
                              v-if="data[indextr].status !== 'processing'"
                              class="apple-action-btn btn-primary"
                              style="margin-top: 4px;"
                              @click="abrirEnviosJob(data[indextr].id)"
                              title="Ver para qual contato cada cobrança foi enviada"
                            >
                              <span>Ver Destinatários</span>
                            </button>
                          </template>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </vs-tab>

            <!-- TAB 3: REGRAS & PERSONALIZAÇÃO DE TEXTOS (APPLE DESIGN) -->
            <vs-tab label="Textos & Condicionais" icon="tune">
              <div class="py-4">
                
                <!-- Cabeçalho com Tipografia Apple e Ações -->
                <div class="mb-4 flex items-center justify-between flex-wrap" style="gap: 12px;">
                  <div>
                    <h5 class="font-bold" style="color: #0f172a; margin: 0; font-size: 16px; letter-spacing: -0.02em; font-family: -apple-system, BlinkMacSystemFont, sans-serif;">
                      Personalização e Mensagens de Cobrança
                    </h5>
                    <p style="color: #64748b; margin: 2px 0 0 0; font-size: 12px; line-height: 1.4;">
                      As informações do cliente (Nome, Nota, Contrato, Valor e Vencimento) são preenchidas dinamicamente pelo Scorpio. Abaixo, edite apenas as instruções de pagamento e chave PIX para cada tipo de cobrança.
                    </p>
                  </div>
                  <div style="display: flex; gap: 8px; align-items: center; flex-wrap: wrap;">
                    <button 
                      class="apple-button-secondary" 
                      @click="abrirModalHistoricoVersoes"
                      title="Ver histórico de versões salvas no banco de dados e restaurar formatos anteriores"
                    >
                      <vs-icon icon="history" size="14px"></vs-icon>
                      <span>Histórico de Versões</span>
                    </button>
                    <button 
                      class="apple-button-secondary" 
                      @click="restaurarTextoPadrao(previewCenario)"
                      title="Restaurar o texto original de fábrica"
                    >
                      <vs-icon icon="refresh" size="14px"></vs-icon>
                      <span>Restaurar Padrão</span>
                    </button>
                    <button 
                      class="apple-button-primary" 
                      @click="salvarTextoPersonalizado"
                      title="Salvar alterações no banco de dados"
                    >
                      <vs-icon icon="cloud_upload" size="14px"></vs-icon>
                      <span>Salvar no Banco</span>
                    </button>
                  </div>
                </div>

                <!-- Apple Segmented Control (Tabs de Cenários) -->
                <div class="apple-segmented-control mb-5 flex-wrap">
                  <button 
                    class="apple-segment-item" 
                    :class="{ 'active': previewCenario === 0 }"
                    @click="previewCenario = 0"
                  >
                    <span class="segment-dot boleto-dot"></span>
                    <span class="segment-title">1. Boleto (≤ 60d)</span>
                  </button>

                  <button 
                    class="apple-segment-item" 
                    :class="{ 'active': previewCenario === 1 }"
                    @click="previewCenario = 1"
                  >
                    <span class="segment-dot renegociacao-dot"></span>
                    <span class="segment-title">2. Expirado (> 60d - PIX)</span>
                  </button>

                  <button 
                    class="apple-segment-item" 
                    :class="{ 'active': previewCenario === 2 }"
                    @click="previewCenario = 2"
                  >
                    <span class="segment-dot pix-dot"></span>
                    <span class="segment-title">3. PIX Direto</span>
                  </button>

                  <button 
                    class="apple-segment-item" 
                    :class="{ 'active': previewCenario === 3 }"
                    @click="previewCenario = 3"
                  >
                    <span class="segment-dot cartao-dot"></span>
                    <span class="segment-title">4. Cartão</span>
                  </button>

                  <button 
                    class="apple-segment-item" 
                    :class="{ 'active': previewCenario === 4 }"
                    @click="previewCenario = 4"
                  >
                    <span class="segment-dot dinheiro-dot"></span>
                    <span class="segment-title">5. Dinheiro / Transf.</span>
                  </button>
                </div>

                <!-- Painel Grid Apple (Editor à Esquerda + WhatsApp à Direita) -->
                <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(360px, 1fr)); gap: 16px;">
                  
                  <!-- COLUNA ESQUERDA: EDITOR DO TEXTO (macOS Style Card) -->
                  <div class="apple-card">
                    <div class="flex items-center justify-between mb-2">
                      <label class="apple-card-label m-0">
                        {{ previewCenario === 0 ? 'Texto de Envio do Boleto (Link Ativo):' : (previewCenario === 1 ? 'Texto de Renegociação e Chave PIX (> 60 dias):' : (previewCenario === 2 ? 'Texto de Instruções e Chave PIX (Direto):' : (previewCenario === 3 ? 'Texto de Pagamento via Cartão:' : 'Texto de Pagamento Dinheiro / Transferência:'))) }}
                      </label>
                      <span class="apple-tag-pill">
                        {{ previewCenario === 0 ? 'Boleto Ativo' : (previewCenario === 1 ? 'Renegociação PIX' : (previewCenario === 2 ? 'PIX Direto' : (previewCenario === 3 ? 'Cartão' : 'Dinheiro/Transf.'))) }}
                      </span>
                    </div>

                    <!-- Textarea macOS com Foco Fluido e Maior Altura -->
                    <div class="mb-3">
                      <textarea 
                        v-if="previewCenario === 1"
                        v-model="textosPersonalizados.renegociacao"
                        rows="8"
                        class="apple-textarea"
                        style="min-height: 160px;"
                        placeholder="Digite o texto de renegociação e chave PIX..."
                      ></textarea>
                      <textarea 
                        v-else-if="previewCenario === 2"
                        v-model="textosPersonalizados.pix"
                        rows="8"
                        class="apple-textarea"
                        style="min-height: 160px;"
                        placeholder="Digite as instruções para pagamento via PIX..."
                      ></textarea>
                      <textarea 
                        v-else-if="previewCenario === 3"
                        v-model="textosPersonalizados.cartao"
                        rows="8"
                        class="apple-textarea"
                        style="min-height: 160px;"
                        placeholder="Digite a instrução para pagamento via Cartão..."
                      ></textarea>
                      <textarea 
                        v-else-if="previewCenario === 4"
                        v-model="textosPersonalizados.dinheiro"
                        rows="8"
                        class="apple-textarea"
                        style="min-height: 160px;"
                        placeholder="Digite a instrução para pagamento em Dinheiro/Transferência..."
                      ></textarea>
                      <textarea 
                        v-else
                        v-model="textosPersonalizados.boleto"
                        rows="8"
                        class="apple-textarea"
                        style="min-height: 160px;"
                        placeholder="Digite a instrução para o boleto..."
                      ></textarea>
                    </div>

                    <!-- Variáveis Dinâmicas Interativas (Clique para Inserir) -->
                    <div class="apple-variables-box">
                      <div class="flex items-center justify-between mb-2">
                        <span class="apple-variables-title">
                          Variáveis Dinâmicas (Clique para inserir no texto):
                        </span>
                      </div>
                      <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                        <button class="apple-var-chip highlight-chip" @click="inserirVariavel('link_boleto')" title="Link único e dinâmico do boleto gerado para este cliente">
                          + {{ '{' + '{' }}link_boleto{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip highlight-chip" @click="inserirVariavel('pix_cnpj')" title="Chave PIX (CNPJ) da empresa favorecida">
                          + {{ '{' + '{' }}pix_cnpj{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('nome')" title="Nome fantasia do cliente">
                          + {{ '{' + '{' }}nome{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('status_vencimento')" title="Status em atraso/pendente">
                          + {{ '{' + '{' }}status_vencimento{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('nota')" title="Número da Nota Fiscal">
                          + {{ '{' + '{' }}nota{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('contrato')" title="Número do Contrato">
                          + {{ '{' + '{' }}contrato{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('valor')" title="Valor formatado em R$">
                          + {{ '{' + '{' }}valor{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('forma_pagamento')" title="Forma de Pagamento">
                          + {{ '{' + '{' }}forma_pagamento{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('favorecido')" title="Nome da Empresa Favorecida">
                          + {{ '{' + '{' }}favorecido{{ '}' + '}' }}
                        </button>
                        <button class="apple-var-chip" @click="inserirVariavel('vencimento')" title="Data de Vencimento">
                          + {{ '{' + '{' }}vencimento{{ '}' + '}' }}
                        </button>
                      </div>
                      <p style="font-size: 11px; color: #64748b; margin: 8px 0 0 0; line-height: 1.4;">
                        💡 <b>Como funciona:</b> No editor você escreve o modelo com as variáveis (ex: <code>{{ '{' + '{' }}link_boleto{{ '}' + '}' }}</code>, <code>{{ '{' + '{' }}pix_cnpj{{ '}' + '}' }}</code>). O Scorpio substitui automaticamente pelos links e dados reais de cada cliente durante o envio. No painel à direita você visualiza a simulação final.
                      </p>
                    </div>
                  </div>

                  <!-- COLUNA DIREITA: PREVIEW DO WHATSAPP (iOS Glass Container) -->
                  <div class="apple-phone-preview-card">
                    <!-- WhatsApp Header -->
                    <div class="wa-chat-header">
                      <div class="flex items-center" style="gap: 8px;">
                        <div class="wa-chat-avatar">
                          <span>SC</span>
                        </div>
                        <div>
                          <div class="wa-chat-name">Grupo EMOPS • Financeiro</div>
                          <div class="wa-chat-status">Conta Comercial Oficial</div>
                        </div>
                      </div>
                      <div class="wa-simulacao-pill">
                        Preview WhatsApp
                      </div>
                    </div>

                    <!-- Seletor de Simulação de Vencimento -->
                    <div class="wa-status-selector-bar">
                      <span style="font-size: 11px; font-weight: 700; color: #075e54;">Simular Status:</span>
                      <div style="display: flex; gap: 4px;">
                        <button 
                          class="wa-status-pill-btn" 
                          :class="{ 'active': previewStatusModo === 'pendente' }"
                          @click="previewStatusModo = 'pendente'"
                        >
                          📋 A Vencer
                        </button>
                        <button 
                          class="wa-status-pill-btn" 
                          :class="{ 'active': previewStatusModo === 'vencido' }"
                          @click="previewStatusModo = 'vencido'"
                        >
                          ⚠️ Em Atraso
                        </button>
                        <button 
                          class="wa-status-pill-btn" 
                          :class="{ 'active': previewStatusModo === 'expirado' }"
                          @click="previewStatusModo = 'expirado'"
                        >
                          🚨 Expirado (> 60d)
                        </button>
                      </div>
                    </div>

                    <!-- WhatsApp Chat Canvas -->
                    <div class="wa-chat-canvas">
                      <!-- Balão de Mensagem Outgoing -->
                      <div class="wa-message-bubble">
                        <div class="wa-bubble-greeting">
                          Olá, <b>FERRAZ DISTRIBUIDORA LTDA</b>! Tudo bem?
                        </div>

                        <div class="wa-bubble-status">
                          <template v-if="previewStatusModo === 'expirado' || previewCenario === 1">
                            ⚠️ <b>VENCIDO HÁ 75 DIAS</b> (venceu em 01/06/2026) - Boleto expirado no banco (Necessário regularização)
                          </template>
                          <template v-else-if="previewStatusModo === 'vencido'">
                            ⚠️ <b>EM ATRASO</b> (venceu em 10/08/2026) - Favor regularizar seu débito
                          </template>
                          <template v-else>
                            📋 <b>PENDENTE</b> (vencimento em 15/08/2026)
                          </template>
                        </div>

                        <div class="wa-bubble-info-card">
                          <div>📄 <b>Nota/Fatura:</b> #91653 | <b>Contrato:</b> #62297308</div>
                          <div>💰 <b>Valor:</b> R$ 1.850,00 | <b>Forma:</b> {{ previewCenario === 1 ? 'PIX / Negociação' : (previewCenario === 2 ? 'PIX' : (previewCenario === 3 ? 'Cartão' : (previewCenario === 4 ? 'Dinheiro' : 'Boleto Bancário'))) }}</div>
                          <div>🏢 <b>Favorecido:</b> E-CONTROL CONTROLE DE PRAGAS LTDA</div>
                        </div>

                        <div class="wa-bubble-instruction">
                          {{ renderizarTextoPreview(previewCenario === 1 ? textosPersonalizados.renegociacao : (previewCenario === 2 ? textosPersonalizados.pix : (previewCenario === 3 ? textosPersonalizados.cartao : (previewCenario === 4 ? textosPersonalizados.dinheiro : textosPersonalizados.boleto)))) }}
                        </div>

                        <div class="wa-bubble-time">
                          <span>14:32</span>
                          <span class="wa-ticks">✓✓</span>
                        </div>
                      </div>
                    </div>

                    <div class="wa-preview-footer">
                      Preview fiel ao que o cliente receberá no WhatsApp
                    </div>
                  </div>

                </div>

              </div>
            </vs-tab>

          </vs-tabs>
        </div>

      </div>
    </vs-popup>

    <!-- MODAL SECUNDÁRIA DE CONFIRMAÇÃO DE CANCELAMENTO -->
    <vs-popup
      :active.sync="modalConfirmarCancelamento"
      title="⚠️ Confirmar Cancelamento"
      class="modal-confirmar-cancelamento"
    >
      <div class="p-4 text-center">
        <vs-icon icon="warning" size="50px" color="#ea5455" class="mb-3"></vs-icon>
        <h4 class="font-bold text-lg mb-2" style="color: #1e293b;">Tem certeza que deseja cancelar o disparo em massa?</h4>
        <p class="text-sm text-grey mb-6" style="color: #64748b;">
          As mensagens já enviadas (<b>{{ progress.sent }}</b> de <b>{{ progress.total }}</b>) não serão desfeitas, mas os envios pendentes serão interrompidos imediatamente.
        </p>
        <div class="flex justify-center items-center" style="gap: 12px;">
          <vs-button color="dark" type="border" @click="modalConfirmarCancelamento = false">
            Não, Continuar Envio
          </vs-button>
          <vs-button color="danger" type="filled" icon="cancel" @click="confirmarCancelamentoJob" :disabled="cancellingJob">
            {{ cancellingJob ? 'Cancelando...' : 'Sim, Cancelar Envio' }}
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- MODAL DE DETALHAMENTO DE FALHAS -->
    <vs-popup
      :active.sync="modalDetalheFalhas"
      title="📋 Relatório Detalhado de Falhas"
      class="modal-detalhe-falhas"
    >
      <div class="py-4 px-2">
        <div v-if="loadingDetalheFalhas" class="text-center py-6">
          <span class="dot-pulse"></span>
          <p class="text-sm text-grey mt-4">Carregando detalhes...</p>
        </div>
        <div v-else-if="detalheFalhasData.length === 0" class="text-center py-6">
          <vs-icon icon="info" size="40px" color="#94a3b8"></vs-icon>
          <p class="text-sm text-grey mt-2">Nenhum detalhe de falha registrado para este disparo.</p>
        </div>
        <div v-else>
          <div class="detalhe-falhas-header mb-3" style="display: flex; justify-content: space-between; align-items: center; gap: 8px;">
            <span class="text-sm font-bold" style="color: #1e293b;">
              {{ detalheFalhasData.length }} falha(s) registrada(s)
            </span>
            <div style="display: flex; gap: 8px;">
              <vs-button color="success" type="border" size="small" icon="table_view" @click="exportarFalhasExcel">
                Exportar Excel
              </vs-button>
              <vs-button color="primary" type="border" size="small" icon="file_download" @click="exportarFalhasCsv">
                Exportar CSV
              </vs-button>
            </div>
          </div>
          <div class="detalhe-falhas-lista">
            <div 
              v-for="(falha, idx) in detalheFalhasData" 
              :key="idx" 
              class="detalhe-falha-item"
            >
              <div class="detalhe-falha-index">#{{ idx + 1 }}</div>
              <div class="detalhe-falha-main">
                <div class="detalhe-falha-cliente">{{ falha.cliente || '-' }}</div>
                <div class="detalhe-falha-conta">Conta #{{ falha.idConta || falha.idOs || '-' }}</div>
              </div>
              <div class="detalhe-falha-contato">
                <span v-if="falha.contatoOriginal" class="text-xs" style="color: #64748b;">{{ falha.contatoOriginal }}</span>
                <span v-else class="text-xs" style="color: #cbd5e1;">sem contato</span>
              </div>
              <div class="detalhe-falha-motivo">
                <vs-chip color="danger" size="small">{{ falha.motivo }}</vs-chip>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-4">
          <vs-button color="dark" type="border" @click="modalDetalheFalhas = false">Fechar</vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- MODAL DE DESTINATÁRIOS DO DISPARO -->
    <vs-popup
      :active.sync="modalEnviosJob"
      title="Destinatários do disparo"
      class="modal-detalhe-falhas"
    >
      <div v-if="loadingEnviosJob" class="text-center py-6">
        <p class="text-sm text-grey">Carregando destinatários...</p>
      </div>
      <div v-else-if="enviosJob.length === 0" class="text-center py-6">
        <p class="text-sm text-grey">Destinatários não registrados para este disparo.</p>
      </div>
      <div v-else class="detalhe-falhas-lista">
        <div v-for="envio in enviosJob" :key="envio.id" class="detalhe-falha-item">
          <div class="detalhe-falha-main">
            <div class="detalhe-falha-cliente">{{ envio.nome_contato || 'Contato não identificado' }}</div>
            <div class="detalhe-falha-conta">Conta #{{ envio.id_conta }} · {{ origemEnvioLabel(envio.origem) }}</div>
          </div>
          <div class="detalhe-falha-contato">
            <span class="text-xs" style="color: #64748b;">{{ envio.contato || 'sem contato' }}</span>
          </div>
          <div class="detalhe-falha-motivo">
            <vs-chip :color="envio.status === 'enviado' ? 'success' : 'danger'" size="small">
              {{ envio.status === 'enviado' ? 'Enviado' : envio.motivo || 'Falha' }}
            </vs-chip>
          </div>
        </div>
      </div>
      <div class="text-center mt-4">
        <vs-button color="dark" type="border" @click="modalEnviosJob = false">Fechar</vs-button>
      </div>
    </vs-popup>

    <!-- MODAL DE HISTÓRICO DE VERSÕES DE TEXTOS NO BANCO -->
    <!-- MODAL DE HISTÓRICO DE VERSÕES DE TEXTOS NO BANCO -->
    <vs-popup
      :active.sync="modalHistoricoVersoes"
      title="📜 Histórico de Versões de Modelos de Cobrança"
      class="modal-historico-versoes"
    >
      <div class="p-4">
        <!-- Banner Informativo com Estilo Apple -->
        <div class="historico-info-banner mb-4">
          <div class="historico-info-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
          </div>
          <div class="historico-info-text">
            <h5 class="historico-info-title">Controle de Versões e Auditoria</h5>
            <p class="historico-info-desc">
              Cada alteração salva é armazenada com histórico completo. Você pode inspecionar os textos de cada formato e restaurar qualquer versão anterior com 1 clique.
            </p>
          </div>
        </div>

        <div v-if="loadingHistoricoVersoes" class="text-center py-8">
          <vs-icon icon="autorenew" size="36px" color="#00bba2" class="spin-icon"></vs-icon>
          <p class="text-xs text-grey-dark mt-2 font-medium">Carregando histórico de versões...</p>
        </div>

        <div v-else-if="historicoVersoesList.length === 0" class="text-center py-8">
          <vs-icon icon="history" size="44px" color="#94a3b8"></vs-icon>
          <p class="text-sm font-semibold text-grey-dark mt-2">Nenhuma versão salva no histórico ainda.</p>
          <p class="text-xs text-grey">Ao salvar novos textos personalizados, eles serão versionados automaticamente aqui.</p>
        </div>

        <div v-else class="historico-versoes-container" style="max-height: 480px; overflow-y: auto; padding-right: 4px;">
          <div 
            v-for="ver in historicoVersoesList" 
            :key="ver.id"
            class="versao-apple-card mb-3"
            :class="{ 'versao-card-ativa': ver.ativo }"
          >
            <!-- Header do Card da Versão -->
            <div class="versao-header flex items-center justify-between flex-wrap" style="gap: 8px;">
              <div class="flex items-center flex-wrap" style="gap: 8px;">
                <span class="versao-tag-numero">v{{ ver.id }}</span>
                <span class="versao-titulo-texto">{{ ver.titulo || 'Personalização de Cobrança' }}</span>
                <span v-if="ver.ativo" class="versao-badge-ativa">
                  <span class="versao-badge-dot"></span> Versão Ativa no Banco
                </span>
              </div>
              <div class="flex items-center" style="gap: 8px;">
                <button 
                  v-if="!ver.ativo"
                  class="apple-button-restore" 
                  @click="confirmarRestauracao(ver.id)"
                  title="Restaurar este conjunto de mensagens como ativo"
                >
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>
                  <span>Restaurar Esta Versão</span>
                </button>
                <span v-else class="versao-status-uso">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  Versão em uso
                </span>
              </div>
            </div>

            <!-- Metadados (Data + Autor) -->
            <div class="versao-meta-row flex items-center text-xs mt-2" style="gap: 16px;">
              <span class="versao-meta-item">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                {{ formatData(ver.created_at || ver.createdAt) }}
              </span>
              <span v-if="ver.nome_usuario || ver.nomeUsuario" class="versao-meta-item">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                Por: <b>{{ ver.nome_usuario || ver.nomeUsuario }}</b>
              </span>
            </div>

            <!-- Botão de Expandir / Recolher Formatos Salvos -->
            <div class="mt-3 pt-2.5" style="border-top: 1px solid #f1f5f9;">
              <button 
                type="button" 
                class="versao-toggle-btn"
                @click="toggleVersaoDetalhes(ver.id)"
              >
                <span class="font-semibold text-xs flex items-center" style="color: #0284c7; gap: 6px;">
                  <svg 
                    width="14" 
                    height="14" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2.5" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"
                    class="versao-chevron-icon"
                    :class="{ 'chevron-rotated': versoesAbertas[ver.id] }"
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                  {{ versoesAbertas[ver.id] ? 'Recolher detalhes dos formatos' : 'Ver formatos salvos nesta versão (' + getContagemFormatos(ver.textos) + ' modelos)...' }}
                </span>
              </button>

              <!-- Painel dos Formatos com Design em Cards Coloridos -->
              <transition name="fade-slide">
                <div v-if="versoesAbertas[ver.id]" class="versao-formatos-grid mt-2.5">
                  <!-- 1. Boleto Válido -->
                  <div class="formato-box formato-boleto">
                    <div class="formato-box-header">
                      <span class="formato-box-icon"><AppIcon name="boleto" size="13" /></span>
                      <span class="formato-box-title">1. Boleto Válido (≤ 60d)</span>
                    </div>
                    <div class="formato-box-content">{{ ver.textos && ver.textos.boleto ? ver.textos.boleto : '-' }}</div>
                  </div>

                  <!-- 2. Renegociação -->
                  <div class="formato-box formato-renegociacao">
                    <div class="formato-box-header">
                      <span class="formato-box-icon"><AppIcon name="alert" size="13" /></span>
                      <span class="formato-box-title">2. Boleto Expirado / Renegociação (> 60d)</span>
                    </div>
                    <div class="formato-box-content">{{ ver.textos && ver.textos.renegociacao ? ver.textos.renegociacao : '-' }}</div>
                  </div>

                  <!-- 3. PIX Direto -->
                  <div class="formato-box formato-pix">
                    <div class="formato-box-header">
                      <span class="formato-box-icon"><AppIcon name="pix" size="13" /></span>
                      <span class="formato-box-title">3. PIX Direto (Chave CNPJ)</span>
                    </div>
                    <div class="formato-box-content">{{ ver.textos && ver.textos.pix ? ver.textos.pix : '-' }}</div>
                  </div>

                  <!-- 4. Cartão -->
                  <div class="formato-box formato-cartao">
                    <div class="formato-box-header">
                      <span class="formato-box-icon"><AppIcon name="card" size="13" /></span>
                      <span class="formato-box-title">4. Cartão de Crédito / Débito</span>
                    </div>
                    <div class="formato-box-content">{{ ver.textos && ver.textos.cartao ? ver.textos.cartao : '-' }}</div>
                  </div>

                  <!-- 5. Dinheiro -->
                  <div class="formato-box formato-dinheiro">
                    <div class="formato-box-header">
                      <span class="formato-box-icon"><AppIcon name="cash" size="13" /></span>
                      <span class="formato-box-title">5. Dinheiro / Espécie</span>
                    </div>
                    <div class="formato-box-content">{{ ver.textos && ver.textos.dinheiro ? ver.textos.dinheiro : '-' }}</div>
                  </div>

                  <!-- 6. Transferência -->
                  <div class="formato-box formato-transferencia" v-if="ver.textos && ver.textos.transferencia">
                    <div class="formato-box-header">
                      <span class="formato-box-icon"><AppIcon name="bank" size="13" /></span>
                      <span class="formato-box-title">6. Transferência / TED / DOC</span>
                    </div>
                    <div class="formato-box-content">{{ ver.textos.transferencia }}</div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <div class="text-center mt-4">
          <vs-button color="dark" type="border" @click="modalHistoricoVersoes = false">Fechar</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { 
  CobrancaCenarioEnum, 
  identificarMeioPagamento, 
  calcularAtraso 
} from "@/constants/cobrancaCenario.js";

export default {
  name: "ModalDisparoEmMassaCobranca",
  props: {
    active: { type: Boolean, default: false },
    contasList: { type: Array, default: () => [] }
  },
  data() {
    return {
      localActive: false,
      modalConfirmarCancelamento: false,
      cancellingJob: false,
      activeJobId: null,
      watiTemplates: [],
      templateSelecionadoId: null,
      contasSelecionadas: [],
      etapa: 'selecao', // 'selecao' | 'progresso'
      abaAtiva: 0,
      previewCenario: 0,
      previewStatusModo: 'pendente', // 'pendente' | 'vencido' | 'expirado'
      textosPersonalizados: {
        boleto: "🔗 *Link do Boleto:* {{link_boleto}}",
        renegociacao: "⚠️ *Aviso:* Devido ao prazo bancário (> 60 dias), este boleto não pode ser pago pelo link original. — 🔑 *Chave PIX (CNPJ) para Quitação:* {{pix_cnpj}} — 💬 _Por favor, responda a esta mensagem para que nossa equipe envie o valor atualizado (juros/multa) ou envie seu comprovante._",
        pix: "🔑 *Chave PIX (CNPJ):* {{pix_cnpj}} — _Nota: Caso opte pelo PIX, por favor envie o comprovante de transferência por este canal para baixa financeira._",
        cartao: "💳 *Instrução:* Pagamento via Cartão de Crédito/Débito registrado no contrato.",
        dinheiro: "💵 *Instrução:* Pagamento em dinheiro/espécie diretamente com o setor financeiro — Favorecido: {{favorecido}}"
      },
      textosPadrao: {
        boleto: "🔗 *Link do Boleto:* {{link_boleto}}",
        renegociacao: "⚠️ *Aviso:* Devido ao prazo bancário (> 60 dias), este boleto não pode ser pago pelo link original. — 🔑 *Chave PIX (CNPJ) para Quitação:* {{pix_cnpj}} — 💬 _Por favor, responda a esta mensagem para que nossa equipe envie o valor atualizado (juros/multa) ou envie seu comprovante._",
        pix: "🔑 *Chave PIX (CNPJ):* {{pix_cnpj}} — _Nota: Caso opte pelo PIX, por favor envie o comprovante de transferência por este canal para baixa financeira._",
        cartao: "💳 *Instrução:* Pagamento via Cartão de Crédito/Débito registrado no contrato.",
        dinheiro: "💵 *Instrução:* Pagamento em dinheiro/espécie diretamente com o setor financeiro — Favorecido: {{favorecido}}"
      },
      historico: [],
      filtroHistoricoDias: 30,
      filtroHistoricoDataInicio: "",
      filtroHistoricoDataFim: "",
      loadingTemplates: false,
      loadingHistorico: false,
      limiteExibicao: 20,
      progress: {
        total: 0,
        sent: 0,
        failed: 0,
        message: 'Aguardando...',
        percent: 0,
        status: ''
      },
      eventSource: null,
      modalDetalheFalhas: false,
      modalEnviosJob: false,
      loadingEnviosJob: false,
      enviosJob: [],
      loadingDetalheFalhas: false,
      detalheFalhasData: [],
      modalHistoricoVersoes: false,
      loadingHistoricoVersoes: false,
      historicoVersoesList: [],
      versaoAtivaId: null,
      salvandoVersaoTexto: false,
      versoesAbertas: {}
    }
  },
  computed: {
    contasElegiveis() {
      // só entra quem tem contato financeiro ou de confirmação válido
      return this.contasList.filter(c => c.destinatarioCobrancaContato);
    },
    totalBoletosValidos() {
      return this.contasElegiveis.filter(c => {
        const dias = c.dias_atraso != null ? Number(c.dias_atraso) : 0;
        const tipoCobranca = String(c.tipo_cobranca || '').toUpperCase();
        return dias <= 60 && tipoCobranca !== 'EXPIRADO_RENEGOCIACAO' && this.isBoleto(c);
      }).length;
    },
    totalExpiradosRenegociacao() {
      return this.contasElegiveis.filter(c => this.isExpirado(c)).length;
    },
    totalPix() {
      return this.contasElegiveis.filter(c => !this.isExpirado(c) && this.isPix(c)).length;
    },
    totalCartao() {
      return this.contasElegiveis.filter(c => !this.isExpirado(c) && this.isCartao(c)).length;
    },
    totalDinheiro() {
      return this.contasElegiveis.filter(c => !this.isExpirado(c) && this.isDinheiro(c)).length;
    },
    totalTransferencia() {
      return this.contasElegiveis.filter(c => !this.isExpirado(c) && this.isTransferencia(c)).length;
    },
    totalOutros() {
      return this.contasElegiveis.filter(c => {
        return !this.isExpirado(c) && !this.isBoleto(c) && !this.isPix(c) && !this.isCartao(c) && !this.isDinheiro(c) && !this.isTransferencia(c);
      }).length;
    },
    contasElegiveisExibidas() {
      return this.contasElegiveis.slice(0, this.limiteExibicao);
    },
    templateSelecionadoNome() {
      const tpl = this.watiTemplates.find(t => t.id === this.templateSelecionadoId);
      return tpl ? tpl.elementName : '—';
    },
    tituloModal() {
      if (this.etapa === 'progresso') return 'Enviando Cobranças...';
      return 'Disparo de Cobrança em Massa via WATI';
    },
    corStatus() {
      if (this.progress.status === 'completed') {
        if (this.progress.failed > 0) {
          if (this.progress.sent === 0) return '#ea5455';
          return '#ff9f43';
        }
        return '#28c76f';
      }
      if (this.progress.status === 'error') return '#ea5455';
      return '#00bba2';
    },
    tabelaDados() {
      if (this.loadingHistorico) {
        return Array.from({ length: 5 }).map((_, index) => ({
          id: `skeleton-${index}`,
          createdAt: '',
          templateName: '',
          status: '',
          enviados: 0,
          totalOs: 0,
          isSkeleton: true
        }));
      }
      return this.historico;
    }
  },
  watch: {
    abaAtiva(val) {
      if (this.localActive) {
        if (val === 1) {
          this.fetchHistorico(true);
        } else {
          this.getWatiTemplates();
        }
      }
    },
    active(val) {
      this.localActive = val;
      if (val) {
        this.templateSelecionadoId = null;
        this.etapa = 'selecao';
        this.limiteExibicao = 20;
        this.historico = [];
        this.contasSelecionadas = this.contasElegiveis.map(c => c.id);
        
        if (this.abaAtiva === 0) {
          this.getWatiTemplates();
        } else {
          this.abaAtiva = 0;
        }
      }
    },
    localActive(val) {
      if (!val) {
        this.closeEventSource();
        this.$emit('update:active', false);
      }
    },
    contasElegiveis(val) {
      if (this.localActive && this.etapa === 'selecao') {
        this.contasSelecionadas = val.map(c => c.id);
      }
    }
  },
  mounted() {
    this.carregarTextosPersonalizados();
  },
  beforeDestroy() {
    this.closeEventSource();
  },
  methods: {
    restaurarTextoPadrao(cenario) {
      if (cenario === 0) this.textosPersonalizados.boleto = this.textosPadrao.boleto;
      if (cenario === 1) this.textosPersonalizados.renegociacao = this.textosPadrao.renegociacao;
      if (cenario === 2) this.textosPersonalizados.pix = this.textosPadrao.pix;
      if (cenario === 3) this.textosPersonalizados.cartao = this.textosPadrao.cartao;
      if (cenario === 4) this.textosPersonalizados.dinheiro = this.textosPadrao.dinheiro;
      this.$vs.notify({ title: "Restaurado", text: "Texto padrão restaurado com sucesso.", color: "primary" });
    },
    async salvarTextoPersonalizado() {
      this.salvandoVersaoTexto = true;
      try {
        const sanitizar = str => typeof str === 'string' ? str.replace(/[\r\n\t]+/g, ' — ').replace(/\s{2,}/g, ' ').trim() : str;
        const textosSanitizados = {};
        Object.keys(this.textosPersonalizados).forEach(k => {
          textosSanitizados[k] = sanitizar(this.textosPersonalizados[k]);
        });
        this.textosPersonalizados = textosSanitizados;

        // Salva no backend
        const res = await this.$http.post("whatsapp/cobranca/salvar-textos-customizados", {
          textos: this.textosPersonalizados,
          titulo: `Personalização salva em ${new Date().toLocaleString('pt-BR')}`
        });
        const responseData = res.data || res;
        const data = responseData.data || responseData;
        if (data && data.versaoId) {
          this.versaoAtivaId = data.versaoId;
        }

        // Salva backup local
        localStorage.setItem("cobranca_textos_custom", JSON.stringify(this.textosPersonalizados));
        this.$vs.notify({ 
          title: "Salvo no Banco", 
          text: "Nova versão salva no banco de dados e aplicada ao sistema!", 
          color: "success" 
        });
        this.fetchHistorico(true);
      } catch (e) {
        console.error(e);
        localStorage.setItem("cobranca_textos_custom", JSON.stringify(this.textosPersonalizados));
        this.$vs.notify({ 
          title: "Salvo Localmente", 
          text: "Textos salvos no navegador (backup local).", 
          color: "warning" 
        });
      } finally {
        this.salvandoVersaoTexto = false;
      }
    },
    async carregarTextosPersonalizados() {
      // 1. Tenta carregar do backend (fonte da verdade)
      try {
        const res = await this.$http.get("whatsapp/cobranca/textos-customizados");
        const responseData = res.data || res;
        const data = responseData.data || responseData;
        if (data && data.textos) {
          this.versaoAtivaId = data.versaoId || null;
          if (data.textos.renegociacao) this.textosPersonalizados.renegociacao = data.textos.renegociacao;
          if (data.textos.pix) this.textosPersonalizados.pix = data.textos.pix;
          if (data.textos.boleto) this.textosPersonalizados.boleto = data.textos.boleto;
          if (data.textos.cartao) this.textosPersonalizados.cartao = data.textos.cartao;
          if (data.textos.dinheiro) this.textosPersonalizados.dinheiro = data.textos.dinheiro;
          localStorage.setItem("cobranca_textos_custom", JSON.stringify(this.textosPersonalizados));
          return;
        }
      } catch (err) {
        console.warn("Não foi possível carregar do backend, usando fallback local:", err);
      }

      // 2. Fallback para localStorage com sanitização
      try {
        const saved = localStorage.getItem("cobranca_textos_custom");
        if (saved) {
          const parsed = JSON.parse(saved);
          if (parsed && typeof parsed === 'object') {
            if (parsed.renegociacao) {
              this.textosPersonalizados.renegociacao = parsed.renegociacao.replace(/16\.825\.779\/0001-14/g, '{{pix_cnpj}}');
            }
            if (parsed.pix) {
              this.textosPersonalizados.pix = parsed.pix.replace(/16\.825\.779\/0001-14/g, '{{pix_cnpj}}');
            }
            if (parsed.boleto) {
              this.textosPersonalizados.boleto = parsed.boleto.replace(/https:\/\/sistemas\.emops\.com\.br[^\s]*/g, '{{link_boleto}}');
            }
            if (parsed.cartao) this.textosPersonalizados.cartao = parsed.cartao;
            if (parsed.dinheiro) this.textosPersonalizados.dinheiro = parsed.dinheiro;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    toggleVersaoDetalhes(verId) {
      this.$set(this.versoesAbertas, verId, !this.versoesAbertas[verId]);
    },
    getContagemFormatos(textos) {
      if (!textos) return 0;
      return Object.keys(textos).filter(k => !!textos[k]).length;
    },
    abrirModalHistoricoVersoes() {
      this.modalHistoricoVersoes = true;
      this.fetchHistoricoVersoes();
    },
    async fetchHistoricoVersoes() {
      this.loadingHistoricoVersoes = true;
      try {
        const res = await this.$http.get("whatsapp/cobranca/historico-textos");
        const responseData = res.data || res;
        this.historicoVersoesList = responseData.data ? responseData.data : (Array.isArray(responseData) ? responseData : []);
      } catch (err) {
        console.error(err);
        this.$vs.notify({ title: "Erro", text: "Erro ao buscar histórico de versões.", color: "danger" });
      } finally {
        this.loadingHistoricoVersoes = false;
      }
    },
    confirmarRestauracao(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: '#00bba2',
        title: 'Confirmar Restauração',
        text: `Deseja realmente restaurar a Versão #${id} como modelo ativo? Os textos atuais da tela serão substituídos.`,
        acceptText: 'Sim, restaurar',
        cancelText: 'Cancelar',
        accept: () => {
          this.restaurarVersaoDoBanco(id);
        }
      });
    },
    async restaurarVersaoDoBanco(id) {
      try {
        const res = await this.$http.post("whatsapp/cobranca/restaurar-versao-texto", { id });
        const responseData = res.data || res;
        const data = responseData.data || responseData;
        if (data && data.textos) {
          this.versaoAtivaId = data.versaoId || id;
          if (data.textos.renegociacao) this.textosPersonalizados.renegociacao = data.textos.renegociacao;
          if (data.textos.pix) this.textosPersonalizados.pix = data.textos.pix;
          if (data.textos.boleto) this.textosPersonalizados.boleto = data.textos.boleto;
          if (data.textos.cartao) this.textosPersonalizados.cartao = data.textos.cartao;
          if (data.textos.dinheiro) this.textosPersonalizados.dinheiro = data.textos.dinheiro;
          localStorage.setItem("cobranca_textos_custom", JSON.stringify(this.textosPersonalizados));
        }
        this.$vs.notify({ 
          title: "Versão Restaurada", 
          text: `Versão #${id} restaurada e ativada com sucesso!`, 
          color: "success" 
        });
        this.modalHistoricoVersoes = false;
      } catch (err) {
        console.error(err);
        this.$vs.notify({ title: "Erro", text: "Erro ao restaurar versão do banco.", color: "danger" });
      }
    },
    inserirVariavel(varName) {
      const tag = '{{' + varName + '}}';
      if (this.previewCenario === 0) this.textosPersonalizados.boleto += ' ' + tag;
      else if (this.previewCenario === 1) this.textosPersonalizados.renegociacao += ' ' + tag;
      else if (this.previewCenario === 2) this.textosPersonalizados.pix += ' ' + tag;
      else if (this.previewCenario === 3) this.textosPersonalizados.cartao += ' ' + tag;
      else if (this.previewCenario === 4) this.textosPersonalizados.dinheiro += ' ' + tag;
      this.$vs.notify({ title: "Variável Inserida", text: `Tag ${tag} adicionada ao texto.`, color: "primary", time: 2000 });
    },
    renderizarTextoPreview(texto) {
      if (!texto) return '';
      let res = String(texto);
      let formaNome = 'Boleto Bancário';
      if (this.previewCenario === 1) formaNome = 'PIX / Negociação';
      else if (this.previewCenario === 2) formaNome = 'PIX';
      else if (this.previewCenario === 3) formaNome = 'Cartão de Crédito';
      else if (this.previewCenario === 4) formaNome = 'Dinheiro';

      let statusNome = 'PENDENTE';
      if (this.previewStatusModo === 'expirado' || this.previewCenario === 1) {
        statusNome = 'VENCIDO HÁ 75 DIAS';
      } else if (this.previewStatusModo === 'vencido') {
        statusNome = 'EM ATRASO';
      }

      res = res.replace(/\{\{\s*link_boleto\s*\}\}/gi, 'https://sistemas.emops.com.br/boleto/218495');
      res = res.replace(/\{\{\s*link\s*\}\}/gi, 'https://sistemas.emops.com.br/boleto/218495');
      res = res.replace(/\{\{\s*pix_cnpj\s*\}\}/gi, '16.825.779/0001-14');
      res = res.replace(/\{\{\s*chave_pix\s*\}\}/gi, '16.825.779/0001-14');
      res = res.replace(/\{\{\s*nome\s*\}\}/gi, 'FERRAZ DISTRIBUIDORA LTDA');
      res = res.replace(/\{\{\s*status_vencimento\s*\}\}/gi, statusNome);
      res = res.replace(/\{\{\s*nota\s*\}\}/gi, '#91653');
      res = res.replace(/\{\{\s*contrato\s*\}\}/gi, '#62297308');
      res = res.replace(/\{\{\s*valor\s*\}\}/gi, 'R$ 1.850,00');
      res = res.replace(/\{\{\s*forma_pagamento\s*\}\}/gi, formaNome);
      res = res.replace(/\{\{\s*favorecido\s*\}\}/gi, 'E-CONTROL CONTROLE DE PRAGAS LTDA');
      res = res.replace(/\{\{\s*vencimento\s*\}\}/gi, '15/08/2026');
      return res;
    },
    closeEventSource() {
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
    },
    closeModal() {
      this.closeEventSource();
      this.localActive = false;
    },
    contatoDestinatario(item) {
      return item.destinatarioCobrancaContato;
    },
    nomeDestinatario(item) {
      return item.destinatarioCobrancaNome;
    },
    origemEnvioLabel(origem) {
      const labels = {
        cliente: 'Cliente',
        financeiro: 'Financeiro',
        confirmacao: 'Confirmação'
      };
      return labels[origem] || 'Sem contato válido';
    },
    async abrirEnviosJob(jobId) {
      this.modalEnviosJob = true;
      this.loadingEnviosJob = true;
      this.enviosJob = [];
      try {
        const res = await this.$http.get(`whatsapp/enviar-massa/envios-cobranca/${jobId}`);
        const responseData = res.data || res;
        this.enviosJob = responseData.data || responseData;
      } catch (err) {
        console.error('Erro ao buscar destinatários do disparo:', err);
        this.$vs.notify({ title: 'Erro', text: 'Erro ao buscar destinatários do disparo.', color: 'danger' });
      } finally {
        this.loadingEnviosJob = false;
      }
    },
    formatarTelefoneExibicao(fone) {
      if (!fone) return 'Contato não informado';
      const str = String(fone).trim();
      const digits = str.replace(/\D/g, '');
      
      // Se for celular com DDD (11 dígitos: 92991508250)
      if (digits.length === 11) {
        return '(' + digits.substring(0, 2) + ') ' + digits.substring(2, 7) + '-' + digits.substring(7);
      }
      // Se for fixo com DDD (10 dígitos: 9232123456)
      if (digits.length === 10) {
        return '(' + digits.substring(0, 2) + ') ' + digits.substring(2, 6) + '-' + digits.substring(6);
      }
      // Se tiver DDI 55 na frente (13 dígitos: 5592991508250)
      if (digits.length === 13 && digits.startsWith('55')) {
        return '(' + digits.substring(2, 4) + ') ' + digits.substring(4, 9) + '-' + digits.substring(9);
      }
      // Se tiver DDI 55 fixo (12 dígitos: 559232123456)
      if (digits.length === 12 && digits.startsWith('55')) {
        return '(' + digits.substring(2, 4) + ') ' + digits.substring(4, 8) + '-' + digits.substring(8);
      }
      return str;
    },
    isTelefoneValido(fone) {
      if (!fone) return false;
      const str = String(fone).trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str)) return false;
      const digits = str.replace(/\D/g, '');
      if (digits.length === 10 || digits.length === 11) return true;
      if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) return true;
      return false;
    },
    isExpirado(item) {
      if (!item) return false;
      if (!this.isBoleto(item)) return false; // Apenas boletos possuem prazo de validade bancária (>60d)
      return calcularAtraso(item).isExpirado60Dias;
    },
    getTipoMeioPagamento(item) {
      return identificarMeioPagamento(item);
    },
    isPix(item) {
      return this.getTipoMeioPagamento(item) === CobrancaCenarioEnum.PIX;
    },
    isBoleto(item) {
      return this.getTipoMeioPagamento(item) === CobrancaCenarioEnum.BOLETO;
    },
    isCartao(item) {
      return this.getTipoMeioPagamento(item) === CobrancaCenarioEnum.CARTAO;
    },
    isDinheiro(item) {
      return this.getTipoMeioPagamento(item) === CobrancaCenarioEnum.DINHEIRO;
    },
    isTransferencia(item) {
      return this.getTipoMeioPagamento(item) === CobrancaCenarioEnum.TRANSFERENCIA;
    },
    getBadgeItem(item) {
      if (!item) return null;
      if (this.isBoleto(item)) {
        if (this.isExpirado(item)) {
          return {
            text: 'Negociação PIX (>60d)',
            class: 'badge-renegociacao',
            type: 'renegociacao',
            title: '⚠️ Boleto expirado no banco (' + (item.dias_atraso || '>60') + ' dias de atraso). O sistema enviará instrução de regularização e chave PIX para negociação com juros/multa.'
          };
        }
        const dias = item.dias_atraso != null ? Number(item.dias_atraso) : (item.diasVencidos != null ? Number(item.diasVencidos) : 0);
        let diasTexto = 'Vence Hoje';
        if (dias > 0) diasTexto = `${dias}d de atraso`;
        else if (dias < 0) diasTexto = `Vence em ${Math.abs(dias)}d`;

        return {
          text: `Boleto (${diasTexto})`,
          class: 'badge-boleto',
          type: 'boleto',
          title: `📄 Boleto Bancário Ativo (${dias > 0 ? dias + ' dias de atraso' : (dias === 0 ? 'Vence Hoje' : 'Vence em ' + Math.abs(dias) + ' dias')}).`
        };
      }
      if (this.isPix(item)) {
        return {
          text: 'PIX',
          class: 'badge-pix',
          type: 'pix',
          title: 'Forma de pagamento via PIX (Chave CNPJ da empresa).'
        };
      }
      if (this.isCartao(item)) {
        return {
          text: 'Cartão',
          class: 'badge-cartao',
          type: 'cartao',
          title: 'Pagamento via Cartão de Crédito/Débito.'
        };
      }
      if (this.isDinheiro(item)) {
        return {
          text: 'Dinheiro',
          class: 'badge-dinheiro',
          type: 'dinheiro',
          title: 'Pagamento em Espécie / Dinheiro.'
        };
      }
      if (this.isTransferencia(item)) {
        return {
          text: 'Transferência',
          class: 'badge-transferencia',
          type: 'transferencia',
          title: 'Transferência Bancária / TED / DOC.'
        };
      }
      const rawNome = String(item.forma_pagamento_nome || item.forma_pagamento || item.formaPagamento || '').toUpperCase();
      const rawId = item.id_forma_pagamento != null ? Number(item.id_forma_pagamento) : null;
      const rawMeio = String(item.tipo_meio_pagamento || '').toUpperCase();

      if (rawId === 10 || rawMeio === 'EMPENHO' || rawNome.includes('EMPENHO')) {
        return {
          text: 'Empenho',
          class: 'badge-empenho',
          type: 'bank',
          title: '🏛️ Pagamento via Empenho (Órgão Público / Governamental).'
        };
      }
      if (rawId === 15 || rawMeio === 'PERMUTA' || rawNome.includes('PERMUTA')) {
        return {
          text: 'Permuta',
          class: 'badge-permuta',
          type: 'sync',
          title: '🤝 Pagamento via Permuta / Contraprestação de Serviços.'
        };
      }
      if (rawId === 16 || rawMeio === 'PAGO_OUTRO_CONTRATO' || rawNome.includes('OUTRO CONTRATO')) {
        return {
          text: 'Outro Contrato',
          class: 'badge-outro-contrato',
          type: 'file',
          title: '📄 Faturamento vinculado e quitado em outro contrato.'
        };
      }
      const nomeOutro = item.forma_pagamento_nome || item.forma_pagamento || item.formaPagamento;
      if (nomeOutro) {
        return {
          text: nomeOutro,
          class: 'badge-outro',
          type: 'outro',
          title: 'Forma de Pagamento: ' + nomeOutro + (rawId ? ' (ID: ' + rawId + ')' : '')
        };
      }
      return null;
    },
    fecharComSucesso() {
      this.$emit('success');
      this.closeEventSource();
      this.localActive = false;
    },
    toggleAll(val) {
      if (val) {
        this.contasSelecionadas = this.contasElegiveis.map(c => c.id);
      } else {
        this.contasSelecionadas = [];
      }
    },
    toggleConta(id) {
      const idx = this.contasSelecionadas.indexOf(id);
      if (idx > -1) {
        this.contasSelecionadas.splice(idx, 1);
      } else {
        this.contasSelecionadas.push(id);
      }
    },
    confirmarEnvio() {
      if (this.contasSelecionadas.length === 0) return;
      this.$vs.dialog({
        type: 'confirm',
        color: '#00bba2',
        title: `Confirmar Disparo`,
        text: `Tem certeza que deseja enviar o template "${this.templateSelecionadoNome}" para ${this.contasSelecionadas.length} cobranças?`,
        acceptText: 'Sim, iniciar',
        cancelText: 'Cancelar',
        accept: this.executarEnvio
      });
    },
    async getWatiTemplates(force = false) {
      if (this.watiTemplates && this.watiTemplates.length > 0 && !force) {
        return;
      }
      this.loadingTemplates = true;
      try {
        let url = "getWatiTemplates?filtro[status][]=approved";
        const res = await this.$http.get(url);
        if (res && res.data) {
          this.watiTemplates = res.data.data || res.data;
        }
      } catch (err) {
        this.$vs.notify({ title: "Erro", text: "Erro ao buscar templates WATI", color: "danger" });
      } finally {
        this.loadingTemplates = false;
      }
    },
    async fetchHistorico(force = false) {
      let queryParams = "";
      if (this.filtroHistoricoDias === 'custom') {
        if (this.filtroHistoricoDataInicio) queryParams += `?data_inicio=${this.filtroHistoricoDataInicio}`;
        if (this.filtroHistoricoDataFim) queryParams += (queryParams ? "&" : "?") + `data_fim=${this.filtroHistoricoDataFim}`;
      } else {
        queryParams += `?dias=${this.filtroHistoricoDias}`;
      }

      if (this.historico && this.historico.length > 0 && !force) {
        return;
      }
      this.loadingHistorico = true;
      if (force) {
        this.historico = [];
      }
      try {
        const res = await this.$http.get(`whatsapp/enviar-massa/historico/cobranca${queryParams}`);
        const responseData = res.data || res;
        this.historico = Array.isArray(responseData) ? responseData : (responseData.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingHistorico = false;
      }
    },
    aoMudarFiltroDias() {
      if (this.filtroHistoricoDias !== 'custom') {
        this.fetchHistorico(true);
      }
    },
    formatData(iso) {
      if (!iso) return '';
      return new Date(iso).toLocaleString('pt-BR');
    },
    getStatusColor(status) {
      if (status === 'completed') return 'success';
      if (status === 'error') return 'danger';
      return 'warning';
    },
    getStatusMeta(status) {
      const s = String(status || '').toLowerCase();
      if (s === 'completed' || s === 'concluido') {
        return {
          class: 'badge-status-completed',
          label: 'COMPLETED',
          icon: 'check'
        };
      }
      if (s === 'cancelled' || s === 'cancelado') {
        return {
          class: 'badge-status-cancelled',
          label: 'CANCELLED',
          icon: 'ban'
        };
      }
      if (s === 'processing' || s === 'processando') {
        return {
          class: 'badge-status-processing',
          label: 'PROCESSANDO',
          icon: 'spin'
        };
      }
      if (s === 'failed' || s === 'error' || s === 'erro') {
        return {
          class: 'badge-status-failed',
          label: 'FALHOU',
          icon: 'alert'
        };
      }
      return {
        class: 'badge-status-default',
        label: (status || 'PENDENTE').toUpperCase(),
        icon: 'clock'
      };
    },
    retomarProgresso(job) {
      if (job.status !== 'processing') return;
      this.activeJobId = job.id;
      this.etapa = 'progresso';
      this.progress = {
        total: job.totalOs,
        sent: job.enviados,
        failed: job.falhas,
        message: 'Reconectando ao envio...',
        percent: Math.round(((job.enviados + job.falhas) / job.totalOs) * 100) || 0,
        status: job.status
      };
      this.iniciarProgressoSSE(job.id);
    },
    abrirModalConfirmarCancelamento() {
      this.modalConfirmarCancelamento = true;
    },
    async confirmarCancelamentoJob() {
      this.cancellingJob = true;
      try {
        await this.$http.post('whatsapp/enviar-massa/cancelar-job', {
          jobId: this.activeJobId,
          tipo: 'cobranca'
        });
        this.progress.status = 'cancelled';
        this.progress.message = 'Disparo cancelado pelo usuário';
        this.closeEventSource();
        this.$vs.notify({
          title: "Cancelado",
          text: "O disparo em massa foi interrompido com sucesso.",
          color: "warning"
        });
        this.fetchHistorico(true);
      } catch (err) {
        this.$vs.notify({
          title: "Erro",
          text: "Falha ao cancelar o disparo.",
          color: "danger"
        });
      } finally {
        this.cancellingJob = false;
        this.modalConfirmarCancelamento = false;
      }
    },
    async executarEnvio() {
      this.etapa = 'progresso';
      this.progress = {
        total: this.contasSelecionadas.length,
        sent: 0,
        failed: 0,
        message: 'Iniciando envio em lote...',
        percent: 0,
        status: 'processing'
      };

      try {
        const template = this.watiTemplates.find(t => t.id === this.templateSelecionadoId);
        const idsContas = this.contasSelecionadas;

        const sanitizar = str => typeof str === 'string' ? str.replace(/[\r\n\t]+/g, ' — ').replace(/\s{2,}/g, ' ').trim() : str;
        const textosSanitizados = {};
        if (this.textosPersonalizados) {
          Object.keys(this.textosPersonalizados).forEach(k => {
            textosSanitizados[k] = sanitizar(this.textosPersonalizados[k]);
          });
        }

        const payload = {
          idsContas,
          templateName: template ? template.elementName : '',
          templateId: this.templateSelecionadoId,
          textosPersonalizados: textosSanitizados
        };

        const res = await this.$http.post("whatsapp/enviarTemplateCobrancaEmMassa", payload);
        const responseData = res.data || res;
        const jobId = responseData.data ? responseData.data.jobId : responseData.jobId;
        this.activeJobId = jobId;
        
        this.iniciarProgressoSSE(jobId);
      } catch (err) {
        this.progress.status = 'error';
        this.progress.message = 'Falha ao iniciar o envio em lote.';
        const errorData = err.response ? err.response.data : {};
        this.$vs.notify({ title: "Erro", text: errorData.message || "Erro ao enviar.", color: "danger" });
      }
    },
    async abrirDetalheFalhas(jobId) {
      this.modalDetalheFalhas = true;
      this.loadingDetalheFalhas = true;
      this.detalheFalhasData = [];
      try {
        const res = await this.$http.get(`whatsapp/enviar-massa/detalhe-falhas/${jobId}`);
        const responseData = res.data || res;
        const data = responseData.data || responseData;
        this.detalheFalhasData = data.detalheFalhas || [];
      } catch (err) {
        console.error('Erro ao buscar detalhe de falhas:', err);
        this.$vs.notify({ title: 'Erro', text: 'Erro ao buscar detalhes de falhas.', color: 'danger' });
      } finally {
        this.loadingDetalheFalhas = false;
      }
    },
    exportarFalhasExcel() {
      if (!this.detalheFalhasData || this.detalheFalhasData.length === 0) return;
      try {
        const XLSX = require('xlsx');
        const rows = [
          ['Conta', 'Cliente', 'Contato Original', 'Motivo da Falha']
        ];
        this.detalheFalhasData.forEach(f => {
          rows.push([
            f.idConta || f.idOs || '-',
            f.cliente || '-',
            f.contatoOriginal || 'Sem contato',
            f.motivo || '-'
          ]);
        });
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(rows);
        ws['!cols'] = [
          { wch: 15 },
          { wch: 35 },
          { wch: 25 },
          { wch: 45 }
        ];
        XLSX.utils.book_append_sheet(wb, ws, 'Falhas');
        const filename = `relatorio_falhas_cobranca_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(wb, filename);
        this.$vs.notify({ title: 'Sucesso', text: 'Planilha Excel gerada com sucesso!', color: 'success' });
      } catch (err) {
        console.error('Erro ao exportar Excel:', err);
        this.$vs.notify({ title: 'Erro', text: 'Erro ao gerar arquivo Excel.', color: 'danger' });
      }
    },
    exportarFalhasCsv() {
      if (!this.detalheFalhasData || this.detalheFalhasData.length === 0) return;
      const header = 'Conta;Cliente;Contato Original;Motivo';
      const linhas = this.detalheFalhasData.map(f => 
        `${f.idConta || f.idOs || '-'};${(f.cliente || '-').replace(/;/g, ',')};${(f.contatoOriginal || '-').replace(/;/g, ',')};${(f.motivo || '-').replace(/;/g, ',')}`
      );
      const csv = [header, ...linhas].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `relatorio_falhas_cobranca_${new Date().toISOString().split('T')[0]}.csv`;
      link.click();
    },
    iniciarProgressoSSE(jobId) {
      const baseUrl = this.$http.defaults.baseURL || '';
      const url = `${baseUrl.replace(/\/$/, '')}/whatsapp/enviar-massa/progress/${jobId}`;
      
      this.eventSource = new EventSource(url);

      this.eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.status === 'error' && data.message === 'Job não encontrado') {
            this.closeEventSource();
            return;
          }
          const oldStatus = this.progress.status;
          this.progress.status = data.status;
          this.progress.total = data.total || this.progress.total;
          this.progress.sent = data.sent || 0;
          this.progress.failed = data.failed || 0;
          this.progress.message = data.message;

          const processados = this.progress.sent + this.progress.failed;
          this.progress.percent = this.progress.total > 0 ? Math.round((processados / this.progress.total) * 100) : 0;

          if (data.status === 'completed') {
            this.progress.percent = 100;
            this.closeEventSource();
            if (oldStatus !== 'completed') {
              this.$vs.notify({ title: "Sucesso!", text: "Disparo de cobrança em massa concluído!", color: "success" });
            }
            this.fetchHistorico(true);
          } else if (data.status === 'error') {
            this.closeEventSource();
            if (oldStatus !== 'error') {
              this.$vs.notify({ title: "Erro", text: data.message || "Erro no servidor.", color: "danger" });
            }
            this.fetchHistorico(true);
          }
        } catch (e) {
          console.error(e);
        }
      };

      this.eventSource.onerror = () => {
        this.closeEventSource();
        if (this.progress.status === 'processing') {
          this.progress.status = 'completed';
          this.$vs.notify({ title: "Aviso", text: "Conexão perdida, mas envios continuam no servidor.", color: "warning" });
          this.fetchHistorico(true);
        }
      };
    }
  }
}
</script>

<style scoped lang="scss">
.progress-section {
  background: #fff;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
}
.progress-container {
  background: #f1f5f9;
  border-radius: 8px;
  padding: 12px;
}
.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.progress-bar-bg {
  width: 100%;
  height: 8px;
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}
.progress-bar-fill {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}
.counters-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.counter-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.counter-value {
  font-size: 20px;
  font-weight: 700;
  margin-top: 4px;
}
.counter-label {
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
}
.info-cards {
  display: flex;
  gap: 12px;
}
.info-card {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid;
}
.info-card-success {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #166534;
}
.info-card-warning {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}
.info-card-number {
  font-size: 16px;
  font-weight: 700;
  display: block;
}
.info-card-text {
  font-size: 11px;
  font-weight: 600;
}
.destinatarios-lista {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #edf2f7;
  border-radius: 6px;
}
.destinatario-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #edf2f7;
}
.destinatario-item:last-child {
  border-bottom: none;
}
.destinatario-main {
  flex: 1;
}
.destinatario-os {
  font-size: 13px;
  font-weight: 700;
  color: #1a202c;
}
.destinatario-cliente {
  font-size: 11px;
  color: #718096;
}
.destinatario-contato {
  font-size: 12px;
  color: #4a5568;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.destinatario-fone.fone-incompleto {
  color: #e11d48;
}
.badge-incompleto {
  display: inline-block;
  background: #ffe4e6;
  color: #e11d48;
  border: 1px solid #fecdd3;
  font-size: 9.5px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 4px;
  margin-left: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.select-label {
  font-size: 12px;
  font-weight: 700;
  color: #4a5568;
  margin-bottom: 6px;
  display: block;
}
.dot-pulse {
  position: relative;
  left: -9999px;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #00bba2;
  color: #00bba2;
  box-shadow: 9999px 0 0 0 #00bba2;
  animation: dotPulse 1.5s infinite linear;
}
@keyframes dotPulse {
  0% {
    box-shadow: 9999px 0 0 -5px #00bba2;
  }
  30% {
    box-shadow: 9999px 0 0 2px #00bba2;
  }
  60%, 100% {
    box-shadow: 9999px 0 0 -5px #00bba2;
  }
}
.detalhe-falhas-lista {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #edf2f7;
  border-radius: 6px;
}
.detalhe-falha-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  gap: 12px;
}
.detalhe-falha-item:last-child {
  border-bottom: none;
}
.detalhe-falha-item:hover {
  background: #f8fafc;
}
.detalhe-falha-index {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  min-width: 28px;
}
.detalhe-falha-main {
  flex: 1;
  min-width: 0;
}
.detalhe-falha-cliente {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detalhe-falha-conta {
  font-size: 11px;
  color: #64748b;
}
.detalhe-falha-contato {
  min-width: 120px;
  text-align: right;
}
.detalhe-falha-motivo {
  min-width: 140px;
}

/* Badges de Tipo de Cobrança / Validade */
.badge-origem-envio {
  background: #ede9fe;
  color: #5b21b6;
  margin-right: 4px;
}
.cobranca-tipo-badge {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 4px;
  line-height: 1.3;
}
.badge-renegociacao {
  background: #fff7ed;
  border: 1px solid #fdba74;
  color: #c2410c;
}
.badge-pix {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #15803d;
}
.badge-boleto {
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  color: #0369a1;
}
.badge-cartao {
  background: #faf5ff;
  border: 1px solid #e9d5ff;
  color: #7e22ce;
}
.badge-dinheiro {
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  color: #047857;
}
.badge-transferencia {
  background: #eef2ff;
  border: 1px solid #c7d2fe;
  color: #4338ca;
}
.badge-outro {
  background: #f8fafc;
  border: 1px solid #cbd5e1;
  color: #475569;
}
.badge-empenho {
  background: #ecfeff;
  border: 1px solid #a5f3fc;
  color: #0e7490;
}
.badge-permuta {
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #b45309;
}
.badge-outro-contrato {
  background: #f5f3ff;
  border: 1px solid #ddd6fe;
  color: #6d28d9;
}

.regra-card:hover {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

/* ==========================================================================
   APPLE DESIGN FOUNDATIONS (Fluid Motion, Refined Typography, Clean Depth)
   ========================================================================== */

.apple-button-primary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #00bba2;
  color: #ffffff;
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 187, 162, 0.25), 0 1px 2px rgba(0, 0, 0, 0.06);
  transition: all 0.15s cubic-bezier(0.16, 1, 0.3, 1);
  outline: none;

  &:hover {
    background: #00a38d;
    box-shadow: 0 2px 6px rgba(0, 187, 162, 0.35);
  }

  &:active {
    transform: scale(0.97);
  }
}

.apple-button-secondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  color: #475569;
  border: 1px solid #cbd5e1;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s cubic-bezier(0.16, 1, 0.3, 1);
  outline: none;

  &:hover {
    background: #f8fafc;
    color: #1e293b;
    border-color: #94a3b8;
  }

  &:active {
    transform: scale(0.97);
  }
}

/* Apple Segmented Control */
.apple-segmented-control {
  display: flex;
  background: #f1f5f9;
  padding: 4px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  gap: 4px;
  width: 100%;
}

.apple-segment-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 8px 12px;
  border: none;
  background: transparent;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  outline: none;
  user-select: none;

  &:hover:not(.active) {
    color: #1e293b;
    background: rgba(255, 255, 255, 0.5);
  }

  &.active {
    background: #ffffff;
    color: #0f172a;
    font-weight: 700;
    box-shadow: 0 2px 8px -1px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04);
  }

  &:active {
    transform: scale(0.98);
  }
}

.segment-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;

  &.boleto-dot { background: #0284c7; }
  &.renegociacao-dot { background: #ea580c; }
  &.pix-dot { background: #00bba2; }
  &.cartao-dot { background: #7e22ce; }
  &.dinheiro-dot { background: #059669; }
}

.segment-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Apple Editor Card */
.apple-card {
  background: #ffffff;
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 10px -2px rgba(0, 0, 0, 0.03);
}

.apple-card-label {
  font-size: 12.5px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}

.apple-tag-pill {
  font-size: 10.5px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 6px;
  background: #f1f5f9;
  color: #475569;
}

.apple-textarea {
  width: 100%;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.45;
  color: #1e293b;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, monospace;
  outline: none;
  resize: vertical;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);

  &:focus {
    background: #ffffff;
    border-color: #00bba2;
    box-shadow: 0 0 0 3px rgba(0, 187, 162, 0.15);
  }
}

/* Variáveis Dinâmicas Apple */
.apple-variables-box {
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  padding: 10px 12px;
}

.apple-variables-title {
  font-size: 11px;
  font-weight: 700;
  color: #475569;
}

.apple-var-chip {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: all 0.12s cubic-bezier(0.16, 1, 0.3, 1);
  outline: none;
  font-family: monospace;

  &:hover {
    background: #f1f5f9;
    border-color: #00bba2;
    color: #00bba2;
  }

  &:active {
    transform: scale(0.96);
  }

  &.highlight-chip {
    background: #f0fdfa;
    border-color: #99f6e4;
    color: #0f766e;
    font-weight: 700;

    &:hover {
      background: #ccfbf1;
      border-color: #00bba2;
      color: #00bba2;
    }
  }
}

/* Apple WhatsApp Preview Container */
.apple-phone-preview-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 16px -2px rgba(0, 0, 0, 0.05);
}

.wa-chat-header {
  background: #0f172a;
  color: #ffffff;
  padding: 10px 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wa-chat-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
}

.wa-chat-name {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.wa-chat-status {
  font-size: 9.5px;
  opacity: 0.85;
}

.wa-simulacao-pill {
  font-size: 10.5px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.15);
  color: #ffffff;
  padding: 2px 8px;
  border-radius: 10px;
}

.wa-status-selector-bar {
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  padding: 6px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
}

.wa-status-pill-btn {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  outline: none;
  transition: all 0.15s ease;

  &:hover {
    color: #00bba2;
    border-color: #00bba2;
  }

  &.active {
    background: #00bba2;
    color: #ffffff;
    border-color: #00bba2;
  }

  &:active {
    transform: scale(0.96);
  }
}

.wa-chat-canvas {
  padding: 14px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #f8fafc;
}

.wa-message-bubble {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px 8px 8px 0;
  padding: 12px 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  font-size: 12px;
  line-height: 1.45;
  color: #1e293b;
  max-width: 100%;
}

.wa-bubble-greeting {
  font-weight: 600;
  color: #00bba2;
  margin-bottom: 6px;
}

.wa-bubble-status {
  margin-bottom: 6px;
  font-size: 11.5px;
}

.wa-bubble-info-card {
  background: #f1f5f9;
  padding: 6px 10px;
  border-radius: 6px;
  margin-bottom: 8px;
  font-size: 11.5px;
  line-height: 1.4;
}

.wa-bubble-instruction {
  border-top: 1px dashed #cbd5e1;
  padding-top: 6px;
  font-size: 11.5px;
  white-space: pre-line;
  line-height: 1.45;
}

.wa-bubble-time {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 3px;
  font-size: 9.5px;
  color: #94a3b8;
  margin-top: 4px;
}

.wa-ticks {
  color: #34b7f1;
  font-weight: 700;
}

.wa-preview-footer {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  padding: 6px 12px;
  text-align: center;
  font-size: 10.5px;
  color: #64748b;
  font-weight: 500;
}

/* ============================================================
   APPLE DESIGN - TAB HISTÓRICO DE ENVIOS
   ============================================================ */
.apple-history-filter-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  flex-wrap: wrap;
}

.filter-periodo-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.filter-bar-label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11.5px;
  font-weight: 700;
  color: #475569;
  letter-spacing: 0.02em;
}

.apple-select-input {
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
  padding: 4px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  outline: none;
  height: 32px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:focus {
    border-color: #0284c7;
    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.1);
  }
}

.filter-custom-dates {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.custom-date-field {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.date-sublabel {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
}

.apple-date-input {
  font-size: 11.5px;
  color: #0f172a;
  padding: 4px 8px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  height: 32px;
  outline: none;
  transition: all 0.15s ease;

  &:focus {
    border-color: #0284c7;
    box-shadow: 0 0 0 3px rgba(2, 132, 199, 0.1);
  }
}

.apple-filter-btn {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 16px;
  background: #00bba2;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 187, 162, 0.25);
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: #00a38d;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 187, 162, 0.35);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(0, 187, 162, 0.2);
  }
}

.apple-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

/* Skeleton Loader Apple-Grade */
.skeleton-cell {
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: appleShimmer 1.5s infinite ease-in-out;
  border-radius: 4px;
  display: inline-block;
}

@keyframes appleShimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.cell-date-container {
  display: flex;
  align-items: center;
}

.cell-date-text {
  font-size: 12.5px;
  font-weight: 500;
  color: #1e293b;
}

.apple-template-code {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  font-weight: 600;
  color: #0284c7;
  background: #f0f9ff;
  padding: 3px 8px;
  border-radius: 6px;
  border: 1px solid #e0f2fe;
}

.apple-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 100px;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 1;

  &.badge-status-completed {
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
  }

  &.badge-status-cancelled {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
  }

  &.badge-status-processing {
    background: #eff6ff;
    color: #0284c7;
    border: 1px solid #bfdbfe;
  }

  &.badge-status-failed {
    background: #fef2f2;
    color: #dc2626;
    border: 1px solid #fecaca;
  }

  &.badge-status-default {
    background: #f8fafc;
    color: #64748b;
    border: 1px solid #e2e8f0;
  }
}

.cell-enviados-container {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  font-size: 13px;
}

.enviados-destaque {
  font-weight: 700;
  color: #0f172a;
}

.enviados-divisor {
  color: #94a3b8;
  font-size: 11px;
}

.enviados-total {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.apple-status-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1;

  &.tag-success {
    background: #f0fdf4;
    color: #15803d;
    border: 1px solid #bbf7d0;
  }
}

.apple-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  line-height: 1;

  &.btn-danger {
    background: #fef2f2;
    color: #b91c1c;
    border: 1px solid #fecaca;

    &:hover {
      background: #fee2e2;
      border-color: #fca5a5;
      transform: translateY(-1px);
      box-shadow: 0 1px 3px rgba(220, 38, 38, 0.1);
    }
  }

  &.btn-primary {
    background: #f0f9ff;
    color: #0369a1;
    border: 1px solid #bae6fd;

    &:hover {
      background: #e0f2fe;
      border-color: #7dd3fc;
      transform: translateY(-1px);
      box-shadow: 0 1px 3px rgba(2, 132, 199, 0.1);
    }
  }
}
</style>

<style lang="scss">
.popper-select-template {
  z-index: 999999 !important;
}

.apple-history-table {
  .vs-table--thead {
    background: #f8fafc;
    th {
      font-size: 11px !important;
      font-weight: 700 !important;
      text-transform: uppercase !important;
      letter-spacing: 0.03em !important;
      color: #475569 !important;
      padding: 10px 14px !important;
      border-bottom: 1px solid #e2e8f0 !important;
    }
  }
  .vs-table--tbody-table {
    tr {
      transition: background 0.15s ease;
      &:hover {
        background: #f8fafc !important;
      }
      td {
        padding: 12px 14px !important;
        border-bottom: 1px solid #f1f5f9 !important;
        font-size: 12px !important;
      }
    }
  }
  .vs-table--pagination {
    padding: 12px 16px !important;
    border-top: 1px solid #e2e8f0 !important;
    background: #fafbfc;
  }
}

/* Modal Principal de Disparo em Massa e Configuração de Textos */
.modal-disparo-massa,
.modal-disparo-massa.vs-component {
  z-index: 200000 !important;
  .vs-popup--background {
    z-index: 200000 !important;
    background: rgba(15, 23, 42, 0.5) !important;
  }
  .vs-popup {
    z-index: 200001 !important;
    max-width: 1240px !important;
    width: 96% !important;
  }
}

/* Modais secundárias dentro do modal de disparo (Histórico de Versões, Detalhes de Falhas, Cancelamento) */
.modal-historico-versoes,
.modal-historico-versoes.vs-component,
.modal-detalhe-falhas,
.modal-detalhe-falhas.vs-component,
.modal-confirmar-cancelamento,
.modal-confirmar-cancelamento.vs-component {
  z-index: 400000 !important;
  .vs-popup--background {
    z-index: 400000 !important;
    background: rgba(15, 23, 42, 0.45) !important;
  }
  .vs-popup {
    z-index: 400001 !important;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4) !important;
  }
}

.modal-historico-versoes .vs-popup {
  max-width: 800px !important;
  width: 92% !important;
  border-radius: 12px !important;
}

.modal-detalhe-falhas .vs-popup {
  max-width: 850px !important;
  width: 92% !important;
  border-radius: 12px !important;
}

.modal-confirmar-cancelamento .vs-popup {
  max-width: 520px !important;
  width: 90% !important;
  border-radius: 12px !important;
}

/* Caixas de diálogo de confirmação do Vuesax ($vs.dialog) - sempre no topo de tudo */
.vs-component.con-vs-dialog,
.vs-dialog-promise,
.con-vs-dialog {
  z-index: 600000 !important;
  .vs-dialog-dark,
  .vs-dialog--background {
    z-index: 600000 !important;
    background: rgba(15, 23, 42, 0.65) !important;
  }
  .vs-dialog {
    z-index: 600001 !important;
    border-radius: 12px !important;
    box-shadow: 0 24px 48px -12px rgba(0, 0, 0, 0.35) !important;
  }
}

/* Tabs Apple Design com Texto Preto e Border Bottom Ciano */
.modal-disparo-massa {
  .vs-tabs--ul {
    border-bottom: 1px solid #e2e8f0 !important;
    box-shadow: none !important;
  }
  .vs-tabs--btn {
    color: #0f172a !important;
    font-weight: 600 !important;
    background: transparent !important;
    border-radius: 0 !important;
    padding: 10px 18px !important;
    border-bottom: 2px solid transparent !important;
    transition: all 0.2s ease !important;

    &:hover {
      color: #00bba2 !important;
    }
  }
  .vs-tabs--btn.active {
    color: #0f172a !important;
    border-bottom: 2px solid #00bba2 !important;
  }
  .vs-tabs--line {
    background: #00bba2 !important;
    height: 2px !important;
  }
}

/* Modal de Histórico de Versões — Apple Grade Design */
.modal-historico-versoes {
  .historico-info-banner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border: 1px solid #e2e8f0;
    border-radius: 10px;

    .historico-info-icon {
      color: #0284c7;
      display: flex;
      align-items: center;
      margin-top: 2px;
    }

    .historico-info-title {
      font-size: 12.5px;
      font-weight: 700;
      color: #0f172a;
      margin: 0 0 2px 0;
    }

    .historico-info-desc {
      font-size: 11px;
      color: #64748b;
      line-height: 1.45;
      margin: 0;
    }
  }

  .versao-apple-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: #cbd5e1;
      box-shadow: 0 6px 16px -4px rgba(0, 0, 0, 0.06);
    }

    &.versao-card-ativa {
      border-left: 4px solid #10b981;
      border-color: #bbf7d0;
      background: #fcfdfd;
    }
  }

  .versao-tag-numero {
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    background: #f1f5f9;
    color: #334155;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
  }

  .versao-titulo-texto {
    font-size: 13.5px;
    font-weight: 700;
    color: #0f172a;
  }

  .versao-badge-ativa {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 2px 9px;
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
    border-radius: 100px;
    font-size: 10.5px;
    font-weight: 700;

    .versao-badge-dot {
      width: 6px;
      height: 6px;
      background: #10b981;
      border-radius: 50%;
    }
  }

  .versao-status-uso {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11.5px;
    font-weight: 700;
    color: #059669;
  }

  .apple-button-restore {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 6px 12px;
    background: #f0fdf4;
    color: #16a34a;
    border: 1px solid #bbf7d0;
    border-radius: 7px;
    font-size: 11.5px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: #dcfce7;
      border-color: #86efac;
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(22, 163, 74, 0.12);
    }
  }

  .versao-meta-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #64748b;
  }

  .versao-toggle-btn {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: none;

    .versao-chevron-icon {
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      &.chevron-rotated {
        transform: rotate(180deg);
      }
    }
  }

  .versao-formatos-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;

    .formato-box {
      border-radius: 9px;
      padding: 10px 12px;
      font-size: 11.5px;
      border: 1px solid #e2e8f0;
      background: #f8fafc;

      .formato-box-header {
        display: flex;
        align-items: center;
        gap: 6px;
        font-weight: 700;
        margin-bottom: 5px;
      }

      .formato-box-content {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 11px;
        line-height: 1.45;
        white-space: pre-wrap;
        color: #334155;
        background: #ffffff;
        padding: 8px 10px;
        border-radius: 6px;
        border: 1px solid #e2e8f0;
      }

      &.formato-boleto {
        background: #f0f9ff;
        border-color: #bae6fd;
        .formato-box-header { color: #0369a1; }
      }

      &.formato-renegociacao {
        background: #fef2f2;
        border-color: #fecaca;
        .formato-box-header { color: #dc2626; }
      }

      &.formato-pix {
        background: #f0fdf4;
        border-color: #bbf7d0;
        .formato-box-header { color: #059669; }
      }

      &.formato-cartao {
        background: #faf5ff;
        border-color: #e9d5ff;
        .formato-box-header { color: #7e22ce; }
      }

      &.formato-dinheiro {
        background: #ecfdf5;
        border-color: #a7f3d0;
        .formato-box-header { color: #047857; }
      }

      &.formato-transferencia {
        background: #eef2ff;
        border-color: #c7d2fe;
        .formato-box-header { color: #4338ca; }
      }
    }
  }
}
</style>
